import React from 'react';

const MongoDB_sort = () => {
  return (
    <div>
      <h1>MongoDB_sort Component</h1>
      <p>This is the MongoDB_sort page.</p>
    </div>
  );
};

export default MongoDB_sort;
